export default {
  // Navegación
  'nav.home': 'Inicio',
  'nav.solutions': 'Soluciones',
  'nav.howWeWork': 'Cómo trabajamos',
  'nav.about': 'Nosotros',

  // CTA compartido
  'cta.shapeYourProject': 'Da forma a tu proyecto',
  'cta.letsMeet': 'Reunámonos',

  // Footer
  'footer.rights': 'Todos los derechos reservados.',

  // Home — Hero
  'home.hero.badge': 'Inteligencia Empresarial',
  'home.hero.slogan': 'One intelligent core. Multiple forms.',
  'home.hero.title1': 'Inteligencia',
  'home.hero.titleShaped': 'moldeada',
  'home.hero.title2': 'alrededor de tu negocio',
  'home.hero.copy':
    'MorphenIQ diseña soluciones de IA a medida, software y datos en torno a tus flujos de trabajo, información privada, sistemas y objetivos de negocio.',
  'home.hero.support':
    'Tu organización tiene su propia forma de trabajar. Tu tecnología debería entenderla.',
  'home.hero.explore': 'Descubre lo que construimos',
  'home.hero.tag.customAi': 'IA a medida',
  'home.hero.tag.privateData': 'Datos privados',
  'home.hero.tag.software': 'Software',
  'home.hero.tag.integrations': 'Integraciones',
  'home.hero.tag.analytics': 'Analítica',
  'home.hero.tag.automation': 'Automatización',
  'home.hero.caption': 'Conecta lo que ya tienes. Construye lo que te falta.',
  'home.hero.flow': 'Sistemas → Inteligencia → Resultados',
  'home.hero.scroll': 'Desliza',

  // Home — Video de introducción
  'home.intro.badge': 'Presentando MorphenIQ',
  'home.intro.title': 'Descubre quiénes somos',
  'home.intro.subtitle':
    'Un vistazo rápido a cómo moldeamos la inteligencia en torno a la forma en que tu negocio realmente funciona.',

  // Home — Genérica vs a medida
  'home.generic.badge': 'Diferenciación con IA',
  'home.generic.title1': 'La IA genérica conoce el mundo.',
  'home.generic.title2': 'La IA a medida conoce tu organización.',
  'home.generic.paragraph':
    'La IA de propósito general entiende el lenguaje y genera contenido. El valor para el negocio se fortalece cuando la inteligencia comprende tu terminología, procesos, sistemas, permisos, datos, usuarios y contexto de negocio.',
  'home.generic.badgeNeural': 'Arquitectura Neuronal',
  'home.generic.badgeTrained': 'Entrenada con tus datos',
  'home.generic.statement1': 'La personalización no es una función.',
  'home.generic.statement2': 'Es nuestra forma de construir.',
  'home.generic.diff.private.label': 'Datos privados',
  'home.generic.diff.private.desc': 'Tu información sigue siendo tuya',
  'home.generic.diff.workflows.label': 'Tus flujos de trabajo',
  'home.generic.diff.workflows.desc': 'Construido en torno a tus procesos',
  'home.generic.diff.roi.label': 'ROI medible',
  'home.generic.diff.roi.desc': 'Resultados de negocio claros',

  // Home — Video final
  'home.outro.badge': 'La visión completa',
  'home.outro.title': 'Donde la inteligencia se convierte en impulso',
  'home.outro.subtitle':
    'Una mirada final a cómo todo lo que construimos se une para hacer avanzar tu negocio.',

  // Home — CTA final
  'home.final.badge': '¿Listo para ir más a fondo?',
  'home.final.title': 'Descubre cómo convertimos desafíos en soluciones',
  'home.final.subtitle': 'Explora los retos que resolvemos y el método detrás de cada proyecto.',
  'home.final.explore': 'Explorar soluciones',
  'home.final.howWeWork': 'Cómo trabajamos',

  // Solutions — Video
  'solutions.video.badge': 'Soluciones',
  'solutions.video.title': 'Inteligencia moldeada en torno a tus desafíos',
  'solutions.video.subtitle':
    'Un vistazo rápido a cómo convertimos la complejidad fragmentada en soluciones unificadas y adaptables.',

  // Solutions — Desafíos
  'solutions.challenges.badge': 'Desafíos de negocio',
  'solutions.challenges.title1': 'La tecnología debería resolver la complejidad,',
  'solutions.challenges.title2': 'no crear más.',
  'solutions.challenges.paragraph': 'Empezamos por el problema — no por un producto predeterminado.',
  'solutions.challenges.p1.title': 'Tu conocimiento está fragmentado.',
  'solutions.challenges.p1.desc':
    'Información dispersa entre documentos, sistemas, correos y la experiencia de unas pocas personas clave.',
  'solutions.challenges.p2.title': 'Tus informes siguen siendo manuales.',
  'solutions.challenges.p2.desc':
    'Los equipos pasan horas recopilando, formateando y distribuyendo datos que deberían fluir automáticamente.',
  'solutions.challenges.p3.title': 'Tus sistemas no se comunican.',
  'solutions.challenges.p3.desc':
    'ERP, CRM, bases de datos y herramientas funcionan de forma aislada, creando trabajo duplicado y silos de datos.',
  'solutions.challenges.p4.title': 'Tus datos existen, pero son difíciles de usar.',
  'solutions.challenges.p4.desc':
    'Información valiosa atrapada en formatos no estructurados, incompatibles o en ubicaciones inaccesibles.',
  'solutions.challenges.p5.title': 'El software estándar no encaja con tu proceso.',
  'solutions.challenges.p5.desc':
    'Las soluciones genéricas obligan a ceder. Tu equipo crea parches en lugar de trabajar con eficiencia.',
  'solutions.challenges.p6.title': 'Quieres IA, pero no sabes por dónde empezar.',
  'solutions.challenges.p6.desc':
    'El potencial está claro. La hoja de ruta no. Necesitas un socio que entienda tanto la tecnología como tu negocio.',
  'solutions.challenges.before.label': 'Fragmentado',
  'solutions.challenges.before.value': 'Antes',
  'solutions.challenges.after.label': 'Unificado',
  'solutions.challenges.after.value': 'Después',
  'solutions.challenges.cta': '¿Reconoces alguno de estos desafíos en tu organización?',

  // Cómo trabajamos — Video
  'howwe.work.video.badge': 'Cómo trabajamos',
  'howwe.work.video.title': 'Descubre cómo damos forma a tu negocio',
  'howwe.work.video.subtitle':
    'Un vistazo rápido a cómo el método MorphenIQ adapta la tecnología a la forma en que tu negocio realmente funciona.',

  // Cómo trabajamos — Filosofía
  'howwe.work.philosophy.badge': 'Filosofía de marca',
  'howwe.work.philosophy.title1': 'Tu negocio tiene su propia lógica.',
  'howwe.work.philosophy.title2': 'Tu tecnología también debería.',
  'howwe.work.traditional.label': 'Tecnología tradicional',
  'howwe.work.traditional.sub': 'El negocio se adapta a la tecnología',
  'howwe.work.traditional.desc':
    'La mayoría del software te pide encajar tus procesos en flujos predefinidos, terminología genérica y estructuras de datos estandarizadas.',
  'howwe.work.traditional.arrow': 'Enfoque rígido, de talla única',
  'howwe.work.morpheniq.label': 'MorphenIQ',
  'howwe.work.morpheniq.sub': 'La tecnología se adapta al negocio',
  'howwe.work.morpheniq.desc':
    'Primero entendemos cómo funciona tu organización y luego moldeamos la inteligencia, el software y la arquitectura de datos en torno a ella.',
  'howwe.work.morpheniq.arrow': 'Adaptable, moldeado a tu medida',
  'howwe.work.statement1': 'No encajamos tu negocio en el software.',
  'howwe.work.statement2': 'Moldeamos la tecnología en torno a tu negocio.',
  'howwe.work.fromRigid': 'De lo rígido a lo adaptable',
  'howwe.work.method': 'El método MorphenIQ',

  // About — Hero
  'about.hero.badge': 'Sobre MorphenIQ',
  'about.hero.title1': 'Inteligencia construida',
  'about.hero.title2': 'en torno a las personas',
  'about.hero.title3': 'moldeada para el negocio.',
  'about.hero.subtitle':
    'MorphenIQ es un socio tecnológico empresarial que diseña soluciones de IA a medida, software, datos y automatización en torno a cómo funciona realmente tu organización — y no al revés.',
  'about.hero.support': 'Creemos que la tecnología debe adaptarse a los negocios, no los negocios a la tecnología.',
  'about.hero.howWeWork': 'Cómo trabajamos',

  // About — Quiénes somos
  'about.who.badge': 'Quiénes somos',
  'about.who.title': 'Un núcleo, muchos resultados inteligentes',
  'about.who.paragraph':
    'MorphenIQ se sitúa entre tus sistemas existentes y los resultados que necesitas. Tomamos lo que ya tienes — documentos, bases de datos, herramientas y procesos — y lo convertimos en inteligencia que tus equipos realmente pueden usar.',
  'about.who.p1.label': 'IA a medida',
  'about.who.p1.text': 'Modelos y asistentes moldeados en torno a tus flujos de trabajo.',
  'about.who.p2.label': 'Software',
  'about.who.p2.text': 'Herramientas y aplicaciones creadas para encajar con tu forma de trabajar.',
  'about.who.p3.label': 'Datos y analítica',
  'about.who.p3.text': 'Convirtiendo información dispersa en decisiones claras.',
  'about.who.p4.label': 'Automatización',
  'about.who.p4.text': 'Eliminando pasos manuales para que tus equipos avancen más rápido.',

  // About — Misión
  'about.mission.badge': 'En qué creemos',
  'about.mission.title': 'Principios que dan forma a cada proyecto',
  'about.mission.paragraph':
    'Nuestra misión es simple: convertir la complejidad organizacional en inteligencia clara y útil sobre la que tus equipos puedan actuar cada día.',
  'about.mission.v1.title': 'Entender primero',
  'about.mission.v1.text':
    'Empezamos aprendiendo cómo trabajan tus equipos, qué datos posees y dónde está la fricción antes de proponer nada.',
  'about.mission.v2.title': 'Respetar tus datos',
  'about.mission.v2.text':
    'Tu información privada sigue siendo tuya. Diseñamos soluciones que funcionan dentro de tus límites de seguridad y cumplimiento.',
  'about.mission.v3.title': 'Construir sobre lo que existe',
  'about.mission.v3.text':
    'Nos integramos con los sistemas que ya usas en lugar de obligarte a reemplazarlos.',
  'about.mission.v4.title': 'Potenciar a tu gente',
  'about.mission.v4.text':
    'La tecnología debe hacer a tus equipos más capaces, no reemplazar su criterio. Construimos herramientas que la gente realmente usa.',

  // About — Equipo
  'about.team.badge': 'Nuestro equipo',
  'about.team.title': 'Las personas detrás de MorphenIQ',
  'about.team.paragraph':
    'Un equipo con décadas de experiencia en ingeniería, datos, IA y dirección de operaciones — guiando cada proyecto desde la estrategia hasta la ejecución.',
  'about.team.viewProfile': 'Ver perfil',
  'about.team.close': 'Cerrar',
  'about.team.comingSoon': 'Próximamente',
  'about.team.comingSoonText': 'Estamos preparando este perfil.',
  'about.team.flipHint': 'Pasa el cursor sobre un perfil para ver su historia completa',

  // About — Equipo: perfiles
  'about.team.m.jorge.role': 'Gerente General (CEO)',
  'about.team.m.jorge.bio':
    'Ingeniero Electrónico, con MBA y un Máster en Big Data y Business Intelligence + IA Empresarial (ENEB). Cuenta con más de tres décadas de experiencia en gerencia, consultoría y dirección de operaciones, y ejerció como Gerente General de Symtek S.A.S. (2015–2023), donde hoy integra la Junta Directiva. Tiene además formación en inteligencia artificial (MIT xPRO) y astronomía. Desde septiembre de 2026 es CEO de MorphenIQ, liderando el desarrollo de agentes de IA.',
  'about.team.m.jorge.tags': ['Liderazgo estratégico', 'Visión de negocio', 'Dirección de operaciones', 'Innovación en IA'],
  'about.team.m.ivan.role': 'Gerente de Ventas y Subgerente (Deputy CEO)',
  'about.team.m.ivan.bio':
    'Ingeniero industrial, especialista en Gestión de Producción y Operaciones, máster en Logística Integral y MBA, actualmente candidato a DBA. Cuenta con 35 años de trayectoria, incluidos 25 como consultor gerencial, asesorando a más de 100 empresas en estrategia, finanzas, operaciones y gobierno corporativo. Es director de ID Management Consulting y profesor en INALDE Business School. En MorphenIQ aporta experiencia ejecutiva, criterio estratégico y relacionamiento directivo para generar oportunidades comerciales de largo plazo.',
  'about.team.m.ivan.tags': ['Estrategia comercial', 'Relacionamiento directivo', 'Consultoría gerencial', 'Gobierno corporativo'],
  'about.team.m.maria.role': 'Gerente de Marketing (CMO)',
  'about.team.m.maria.bio':
    'Profesional en Marketing y Negocios Digitales y Administración de Negocios Internacionales, con un MSc en Strategic and Digital Marketing de Rennes School of Business, Francia. Cuenta con experiencia internacional como consultora de marketing en estrategia, redes sociales, sitios web, eventos, posicionamiento de marca y analítica. En MorphenIQ aporta en el desarrollo de marca, comunicación y estrategia comercial, combinando creatividad, pensamiento estratégico, capacidad analítica y orientación a resultados para fortalecer el posicionamiento de la compañía.',
  'about.team.m.maria.tags': ['Creatividad', 'Pensamiento estratégico', 'Capacidad analítica', 'Orientación a resultados'],
  'about.team.m.claudia.role': 'Líder de Implementación de Proyectos de IA',
  'about.team.m.claudia.bio':
    'Ingeniera de Sistemas (U. Piloto), con Maestría en Sistemas de Información (U. Javeriana), Máster en Ingeniería de Software (DePaul University, USA) y Especialización en IA (MIT). Con 20 años de experiencia en sectores de tecnología, salud, financiero, educación y gobierno, fue CTO de Topiary Communications, donde lideró SHARP para O\'Hare Airport, requerimiento de la FAA. Ha liderado proyectos de IA como SABIIA (DePaul University) y SpectraBot (Symtek S.A.S). Desde septiembre de 2026 lidera Proyectos de IA en MorphenIQ.',
  'about.team.m.claudia.tags': ['Implementación de proyectos', 'Arquitectura de software', 'Liderazgo técnico', 'Experiencia multisectorial'],
  'about.team.m.william.role': 'Coordinador de Diseño y Desarrollo',
  'about.team.m.william.bio':
    'Ingeniero de Sistemas con especialización en Gestión de Proyectos Educativos y más de 20 años de experiencia en desarrollo de software, liderazgo técnico y formación tecnológica. Posee amplia experiencia en arquitectura, desarrollo backend, bases de datos e integración de sistemas. Se destaca por liderar equipos y resolver problemas complejos. Actualmente, en MorphenIQ, apoya el desarrollo tecnológico de soluciones basadas en Inteligencia Artificial, analítica de datos, automatización y transformación digital, aportando innovación y visión estratégica.',
  'about.team.m.william.tags': ['Arquitectura de software', 'Desarrollo backend', 'Liderazgo técnico', 'Transformación digital'],
  'about.team.m.evilio.role': 'Arquitecto de Software',
  'about.team.m.evilio.bio':
    'Ingeniero de Sistemas con especialización en Gerencia de Proyectos, con sólida trayectoria en arquitectura de software y liderazgo técnico. Destaca su diseño de la arquitectura del sistema logístico de 4-72 (SIPOST), en .NET, que soporta la operación nacional, y su liderazgo en la arquitectura de XTAM, plataforma de videovigilancia y analítica. En MorphenIQ se desempeña como Arquitecto de Software, aportando visión estratégica para soluciones robustas que impulsan la transformación digital.',
  'about.team.m.evilio.tags': ['Arquitectura de software', 'Liderazgo técnico', 'Gerencia de proyectos', 'Transformación digital'],

  // About — Beneficios
  'about.benefits.badge': 'Por qué trabajar con nosotros',
  'about.benefits.title': 'Los beneficios de construir con MorphenIQ',
  'about.benefits.paragraph':
    'Trabajar con un socio que moldea la tecnología en torno a tu negocio lo cambia todo — desde lo rápido que ves resultados hasta lo que cuesta a largo plazo.',
  'about.benefits.b1.title': 'Valor más rápido',
  'about.benefits.b1.text':
    'Entregamos soluciones funcionales en semanas, no en trimestres. Ves resultados pronto y con frecuencia, en lugar de esperar un gran lanzamiento.',
  'about.benefits.b2.title': 'Construido en torno a tus flujos',
  'about.benefits.b2.text':
    'Sin plantillas genéricas. Cada solución refleja tus procesos exactos, terminología y estructuras de datos desde el primer día.',
  'about.benefits.b3.title': 'Seguridad de nivel empresarial',
  'about.benefits.b3.text':
    'Tus datos permanecen dentro de tus límites. Trabajamos con tus requisitos de cumplimiento, gobernanza y control de acceso.',
  'about.benefits.b4.title': 'Menor coste total de propiedad',
  'about.benefits.b4.text':
    'Al conectar lo que ya tienes y construir solo lo que falta, evitas costosos proyectos de reemplazo total.',
  'about.benefits.b5.title': 'Un socio integrado',
  'about.benefits.b5.text':
    'IA, software, datos, integraciones, analítica y automatización bajo un mismo techo — sin hacer malabares con múltiples proveedores.',
  'about.benefits.b6.title': 'Impacto de negocio medible',
  'about.benefits.b6.text':
    'Cada proyecto está ligado a resultados concretos: horas ahorradas, errores reducidos, decisiones aceleradas, ingresos desbloqueados.',
  'about.benefits.cta': 'Inicia una conversación',

  // About — Diagrama central
  'about.core.cap.customAi.label': 'IA a medida',
  'about.core.cap.customAi.text': 'Asistentes y modelos',
  'about.core.cap.software.label': 'Software',
  'about.core.cap.software.text': 'Apps y plataformas',
  'about.core.cap.data.label': 'Datos y analítica',
  'about.core.cap.data.text': 'Insights y paneles',
  'about.core.cap.automation.label': 'Automatización',
  'about.core.cap.automation.text': 'Flujos y agentes',
  'about.core.cap.integrations.label': 'Integraciones',
  'about.core.cap.integrations.text': 'Conecta tu stack',
  'about.core.cap.security.label': 'Seguridad',
  'about.core.cap.security.text': 'Confianza empresarial',

  // Da forma a tu proyecto
  'shape.badge': 'Inicia la conversación',
  'shape.title': 'Da forma a tu proyecto',
  'shape.subtitle':
    'Cuéntanos qué intentas resolver. No necesitas saber exactamente qué tecnología necesitas — nosotros te ayudaremos a dar forma a la solución adecuada.',
  'shape.success.title': 'Gracias',
  'shape.success.text':
    'Hemos recibido tu consulta. Nuestro equipo revisará los detalles de tu proyecto y se pondrá en contacto contigo en un plazo de dos días laborables.',
  'shape.name.label': 'Tu nombre',
  'shape.name.placeholder': 'Tu nombre completo',
  'shape.contact.label': 'Número de contacto o WhatsApp',
  'shape.contact.placeholder': '+34 600 000 000 (opcional)',
  'shape.challenge.label': '¿Qué desafío estás intentando resolver?',
  'shape.challenge.placeholder':
    'Describe el problema de negocio, el proceso o la oportunidad que quieres abordar...',
  'shape.challenge.max': 'Máximo 500 caracteres',
  'shape.category.label': 'Categoría del desafío',
  'shape.category.placeholder': 'Selecciona una categoría',
  'shape.systems.label': '¿Qué sistemas, plataformas o fuentes de datos están involucrados?',
  'shape.systems.placeholder': 'ERP, CRM, bases de datos, documentos, APIs, etc.',
  'shape.stage.label': '¿En qué punto te encuentras en tu proyecto?',
  'shape.stage.placeholder': 'Selecciona tu etapa',
  'shape.company.label': 'Empresa',
  'shape.company.placeholder': 'Nombre de la organización',
  'shape.role.label': 'Tu cargo',
  'shape.role.placeholder': 'p. ej. CTO, Director de Operaciones',
  'shape.country.label': 'País',
  'shape.country.placeholder': 'País',
  'shape.email.label': 'Correo corporativo',
  'shape.email.placeholder': 'tu@empresa.com',
  'shape.privacy':
    'Respetamos tu privacidad. Tu información solo se utilizará para responder a tu consulta.',
  'shape.submitting': 'Enviando...',
  'shape.error.generic': 'Algo salió mal. Por favor, inténtalo de nuevo.',
  'shape.cat.knowledge': 'Gestión del conocimiento y búsqueda',
  'shape.cat.reporting': 'Informes y analítica',
  'shape.cat.integration': 'Integración de sistemas',
  'shape.cat.data': 'Estructuración y acceso a datos',
  'shape.cat.automation': 'Automatización de procesos',
  'shape.cat.software': 'Necesidad de software a medida',
  'shape.cat.ai': 'Estrategia y hoja de ruta de IA',
  'shape.cat.other': 'Otro',
  'shape.stage.exploring': 'Explorando posibilidades',
  'shape.stage.defined': 'Desafío definido, sin solución',
  'shape.stage.concept': 'Tengo un concepto, necesito validarlo',
  'shape.stage.ready': 'Listo para construir',
  'shape.stage.existing': 'Tengo un sistema existente, necesito evolucionarlo',

  // Agendar reunión
  'meeting.badge': 'Agenda una reunión',
  'meeting.title': 'Hablemos de tu proyecto',
  'meeting.subtitle': 'Selecciona una fecha y hora que te funcione. Sin compromiso.',
  'meeting.openCalendly': 'Abrir en Calendly',
  'meeting.duration': '45 minutos',
  'meeting.durationLabel': 'Duración',
  'meeting.typeLabel': 'Tipo de reunión',
  'meeting.typeValue': 'Descubrimiento de proyecto',
  'meeting.aboutLabel': 'Sobre la reunión',
  'meeting.aboutText': 'Hablaremos de tu desafío, tus sistemas actuales y cómo MorphenIQ puede ayudarte a moldear la solución adecuada. Sin pitch de ventas. Solo una conversación útil.',
  'meeting.prepLabel': 'Preparación',
  'meeting.prep1': 'Ten a mano una breve descripción del reto que enfrentas.',
  'meeting.prep2': 'Piensa en los sistemas o datos que están involucrados.',
  'meeting.prep3': 'No necesitas una propuesta técnica lista — nosotros ayudamos con eso.',
  'meeting.iframeTitle': 'Calendario de reuniones de MorphenIQ',
  'meeting.successTitle': '¡Reunión agendada!',
  'meeting.successText': 'Tu reunión quedó confirmada. Recibirás un correo con el enlace de Google Meet, la fecha y la hora.',
  'meeting.backHome': 'Volver al inicio',
  'meeting.timezoneLabel': 'Zona horaria',
  'meeting.timezoneValue': 'Américas (Bogotá, Jamaica, Lima, etc.)',
  'meeting.availabilityLabel': 'Disponibilidad',
  'meeting.availabilityValue': 'Lun – Vie, 8:00 AM – 5:00 PM',
  'meeting.afterLabel': 'Después de la reunión',
  'meeting.afterText': 'Te enviaremos un resumen de seguimiento con los siguientes pasos, una estimación de tiempo y una propuesta adaptada a tus necesidades.',
  'meeting.languageLabel': 'Idiomas',
  'meeting.languageValue': 'Inglés / Español',

  // Diagramas — Comparación
  'diagram.compare.generic.title': 'IA genérica',
  'diagram.compare.generic.subtitle': 'Conoce el mundo',
  'diagram.compare.custom.title': 'IA a medida de MorphenIQ',
  'diagram.compare.custom.subtitle': 'Conoce tu organización',
  'diagram.compare.generic.item1': 'Conocimiento general',
  'diagram.compare.generic.item2': 'Flujos de trabajo genéricos',
  'diagram.compare.generic.item3': 'Lenguaje amplio',
  'diagram.compare.generic.item4': 'Interfaces estándar',
  'diagram.compare.generic.item5': 'Contexto de negocio limitado',
  'diagram.compare.custom.item1': 'Conocimiento organizacional',
  'diagram.compare.custom.item2': 'Tus flujos de trabajo',
  'diagram.compare.custom.item3': 'Tu terminología',
  'diagram.compare.custom.item4': 'Experiencia por roles',
  'diagram.compare.custom.item5': 'Tus reglas de negocio',
  'diagram.compare.custom.item6': 'Datos privados autorizados',
  'diagram.compare.custom.item7': 'Diseño específico del contexto',

  // Diagramas — Proceso
  'diagram.process.step1.label': 'ENTENDER',
  'diagram.process.step1.desc': 'Negocio, procesos, usuarios, sistemas, datos',
  'diagram.process.step2.label': 'DAR FORMA',
  'diagram.process.step2.desc': 'Caso de uso, arquitectura, lógica, UX, seguridad',
  'diagram.process.step3.label': 'CONSTRUIR',
  'diagram.process.step3.desc': 'IA, software, integraciones, paneles',
  'diagram.process.step4.label': 'PROBAR',
  'diagram.process.step4.desc': 'Adopción, precisión, ahorros, ROI',
  'diagram.process.step5.label': 'EVOLUCIONAR',
  'diagram.process.step5.desc': 'Nuevos sistemas, usuarios, datos, casos de uso',

  // Diagramas — Flujo de inteligencia
  'diagram.flow.zone.systems': 'TUS SISTEMAS',
  'diagram.flow.zone.outputs': 'SALIDAS INTELIGENTES',
  'diagram.flow.zone.core': 'NÚCLEO MORPHENIQ',
  'diagram.flow.input.documents': 'Documentos',
  'diagram.flow.input.erp': 'ERP',
  'diagram.flow.input.crm': 'CRM',
  'diagram.flow.input.databases': 'Bases de datos',
  'diagram.flow.input.apis': 'APIs',
  'diagram.flow.input.bi': 'Herramientas BI',
  'diagram.flow.output.assistant': 'Asistente IA',
  'diagram.flow.output.dashboards': 'Paneles',
  'diagram.flow.output.reports': 'Informes',
  'diagram.flow.output.automation': 'Automatización',
  'diagram.flow.output.applications': 'Aplicaciones',
  'diagram.flow.output.decisions': 'Decisiones',

  // Calendario de reservas
  'booking.stepDate': 'Elige fecha',
  'booking.stepTime': 'Elige hora',
  'booking.stepReview': 'Tus datos',
  'booking.loading': 'Cargando horarios disponibles...',
  'booking.error': 'Algo salió mal al cargar la disponibilidad.',
  'booking.retry': 'Reintentar',
  'booking.noSlots': 'No hay horarios disponibles por el momento.',
  'booking.chooseDate': 'Selecciona una fecha',
  'booking.chooseTime': 'Selecciona una hora',
  'booking.yourMeeting': 'Confirma tu reunión',
  'booking.dateLabel': 'Fecha',
  'booking.startLabel': 'Inicio',
  'booking.endLabel': 'Fin',
  'booking.modifyTime': 'Modificar hora',
  'booking.modifyDate': 'Cambiar fecha',
  'booking.nameLabel': 'Tu nombre',
  'booking.namePlaceholder': 'Nombre completo',
  'booking.phoneLabel': 'Teléfono',
  'booking.phonePlaceholder': '+34 600 000 000',
  'booking.emailLabel': 'Correo electrónico',
  'booking.emailPlaceholder': 'tu@empresa.com',
  'booking.emailInvalid': 'Por favor, escribe un correo válido.',
  'booking.optionalTitle': 'Cuéntanos sobre tu proyecto (opcional)',
  'booking.optionalHint': 'Estas respuestas nos ayudan a prepararnos y llegar a la reunión con ideas concretas. No es obligatorio.',
  'booking.challengeLabel': '¿Qué desafío estás intentando resolver?',
  'booking.challengePlaceholder': 'Describe el problema de negocio, el proceso o la oportunidad que quieres abordar...',
  'booking.categoryLabel': 'Categoría del desafío',
  'booking.categoryPlaceholder': 'Selecciona una categoría',
  'booking.systemsLabel': '¿Qué sistemas, plataformas o fuentes de datos están involucrados?',
  'booking.systemsPlaceholder': 'ERP, CRM, bases de datos, documentos, APIs, etc.',
  'booking.stageLabel': '¿En qué punto te encuentras en tu proyecto?',
  'booking.stagePlaceholder': 'Selecciona tu etapa',
  'booking.companyLabel': 'Empresa',
  'booking.companyPlaceholder': 'Nombre de la organización',
  'booking.roleLabel': 'Tu cargo',
  'booking.rolePlaceholder': 'p. ej. CTO, Director de Operaciones',
  'booking.countryLabel': 'País',
  'booking.countryPlaceholder': 'País',
  'booking.notesLabel': 'Notas (opcional)',
  'booking.notesPlaceholder': 'Algo que quieras que sepamos antes de la llamada...',
  'booking.requiredError': 'Por favor, rellena tu nombre y teléfono.',
  'booking.categories': [
    'Gestión del conocimiento y búsqueda',
    'Informes y analítica',
    'Integración de sistemas',
    'Estructuración y acceso a datos',
    'Automatización de procesos',
    'Necesidad de software a medida',
    'Estrategia y hoja de ruta de IA',
    'Otro',
  ],
  'booking.stages': [
    'Explorando posibilidades',
    'Desafío definido, sin solución',
    'Tengo un concepto, necesito validarlo',
    'Listo para construir',
    'Tengo un sistema existente, necesito evolucionarlo',
  ],
  'booking.submit': 'Confirmar reserva',
  'booking.submitting': 'Reservando...',
  'booking.successTitle': '¡Ya estás agendado!',
  'booking.successText': 'Tu reunión está confirmada. Te enviaremos una confirmación e invitación de calendario en breve.',
  'booking.bookAnother': 'Agendar otra reunión',
  'booking.months': ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
  'booking.weekdays': ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
  'booking.prevMonth': 'Mes anterior',
  'booking.nextMonth': 'Mes siguiente',
};